class SimError {
  constructor(message, name, stack) {
    this.message = message;
    this.name = name;
    this.stack = stack;
  }
}
export {
  SimError
};
//# sourceMappingURL=SimError.js.map
